export default __webpack_public_path__ + "img/no_image_set.png";